// src/components/BlogSection.jsx
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Pagination } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 3;

  // Fetch blogs from backend
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await axios.get("http://localhost:5000/api/blogs");
        setBlogs(res.data);
      } catch (err) {
        console.error("Error fetching blogs:", err);
      }
    };
    fetchBlogs();
  }, []);

  // Pagination calculations
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <>
      <Helmet>
        <title>Our Blogs | Bangalore Distance Education</title>
        <meta
          name="description"
          content="Read our blogs on Bangalore Distance Education, distance learning courses, and online degree courses in Bangalore. Stay updated with tips and insights."
        />
      </Helmet>

      <section
        style={{
          padding: "60px 0",
          backgroundColor: "#F5F5F5",
          marginTop: "50px",
        }}
      >
        <Container>
          <h1 className="text-center mb-5">Latest Blogs & Insights</h1>

          <Row>
            {currentBlogs.map((blog) => (
              <Col md={4} key={blog._id} className="mb-4">
                <Card
                  as={Link}
                  to={`/blog/${blog._id}`}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    border: "none",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                    borderRadius: "12px",
                    overflow: "hidden",
                    display: "block",
                  }}
                >
                  {blog.image && (
                    <Card.Img
                      variant="top"
                      src={`http://localhost:5000${blog.image}`} // serve uploaded image
                      alt={blog.title}
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                  )}
                  <Card.Body>
                    <p
                      style={{
                        fontSize: "13px",
                        color: "#6c757d",
                        marginBottom: "8px",
                      }}
                    >
                      <span style={{ color: "#007bff", fontWeight: "600" }}>
                        ARTICLE
                      </span>{" "}
                      | in {blog.categories?.join(", ")}
                    </p>
                    <Card.Title
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        lineHeight: "1.4",
                      }}
                    >
                      {blog.title}
                    </Card.Title>
                    {blog.author && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "15px",
                        }}
                      >
                        {blog.authorImage && (
                          <img
                            src={blog.authorImage}
                            alt={blog.author}
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              marginRight: "10px",
                            }}
                          />
                        )}
                        <div style={{ fontSize: "14px" }}>
                          <div style={{ fontWeight: "600" }}>{blog.author}</div>
                          <div style={{ color: "#6c757d", fontSize: "13px" }}>
                            {new Date(blog.createdAt).toLocaleDateString()}
                          </div>
                        </div>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Pagination */}
          <div className="d-flex justify-content-center mt-4">
            <Pagination>
              <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1} />
              {[...Array(totalPages)].map((_, index) => (
                <Pagination.Item
                  key={index + 1}
                  active={index + 1 === currentPage}
                  onClick={() => setCurrentPage(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={handleNext}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Blog;
